import { Stage } from "../../types/pipeline";
import { Card } from "./Card";

interface Props {
    stage: Stage;
}

export function StageContainer({ stage }: Props) {
    return (
        <div className="flex flex-col gap-y-1 overflow-hidden">

            {/* datos de la etapa */}
            <div className="border-0 border-black bg-slate-200 py-2 rounded h-[100px] shadow-sm">
                <div className="mx-2">
                    <p className="text-l font-semibold">{stage.nombre}</p>
                    <p className="text-sm font-medium text-gray-600">{stage.deals.length} {stage.deals.length == 1 ? "campaña" : "campañas"}</p>
                </div>
            </div>

            {/* contenedor de las cards */}
            <div className="flex flex-col gap-y-3 h-full bg-slate-200 items-center font-semibold text-[15px] py-2 rounded shadow-sm overflow-auto">

                {stage.deals.map((deal, index) => (
                    <Card
                        key={index}
                        deal={deal}
                        enableRottingIn={stage.enableRottingIn}
                        rottingInDays={stage.rottingInDays}/>
                ))}

            </div>
        </div>
    );
}